var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import scallopMaskSrc from '@images/marketing/masks/ScallopedPink.svg?url';
import FunnelScallopedBorderLarge from '@svgs/funnel/ScallopOutlineLarge.svg';
import FunnelScallopedBorder from '@svgs/funnel/ScallopOutlineSmall.svg';
import ScallopedBorderDark from '@svgs/global/Star_Dark.svg';
import ScallopedBorderDarkLarge from '@svgs/global/Star_Dark_Large.svg';
import ScallopedBorderLight from '@svgs/global/Star_Light.svg';
import ScallopedBorderLightLarge from '@svgs/global/Star_Light_Large.svg';
var scallopMaskSVG = {
    funnel: {
        small: {
            light: FunnelScallopedBorder,
            dark: FunnelScallopedBorder,
        },
        large: {
            light: FunnelScallopedBorderLarge,
            dark: FunnelScallopedBorderLarge,
        },
    },
    global: {
        small: {
            light: ScallopedBorderDark,
            dark: ScallopedBorderLight,
        },
        large: {
            light: ScallopedBorderDarkLarge,
            dark: ScallopedBorderLightLarge,
        },
    },
};
function ScallopedImage(_a) {
    var _b = _a.height, height = _b === void 0 ? 306 : _b, imgData = _a.imgData, _c = _a.size, size = _c === void 0 ? 'small' : _c, _d = _a.theme, theme = _d === void 0 ? 'light' : _d, _e = _a.use, use = _e === void 0 ? 'global' : _e;
    var SVG = scallopMaskSVG[use][size][theme];
    return (_jsxs("div", __assign({ className: "relative overflow-hidden", style: {
            height: "".concat(height, "px"),
            width: "".concat(height, "px"),
        } }, { children: [_jsx(SVG, { height: "100%", width: "100%", style: {
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    zIndex: 2,
                } }), _jsx("img", { className: "absolute w-full h-full top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 object-cover z-1", style: {
                    maskImage: "url(".concat(scallopMaskSrc, ")"),
                    maskRepeat: 'no-repeat',
                    maskSize: size === 'small' ? 'calc(100% - 2px)' : 'calc(98%)',
                    maskPosition: size === 'small' ? 'center' : '2px 2px',
                }, alt: imgData.alt, src: imgData.src })] })));
}
export default ScallopedImage;
